import React from 'react';
import { BsGithub, BsLinkedin, BsWebcamFill } from "react-icons/bs";

import './About.css';

function About() {
  return (
    <div className="about-container">
      <h1 className="about-heading">About Me</h1>
      <h3 className="about-subheading">Hi, I'm Shantanu Tiwari</h3>
      <p className="about-paragraph">
        I'm a passionate <span className="highlight-text">Software Developer</span> with a strong focus on creating
        user-centric web applications. My primary language of choice is <span className="highlight-text">React.js and Next.js</span>,
        and I thrive on transforming complex ideas into intuitive and elegant user interfaces.
      </p>
      <p className="about-paragraph">
        With a keen eye for design and a deep understanding of user experience principles, I aim to craft digital
        experiences that not only look visually appealing but also function seamlessly.
      </p>
      <p className="about-paragraph">
        I'm dedicated to staying up-to-date with the latest trends and technologies in the UI/UX field. I enjoy
        collaborating with cross-functional teams to turn concepts into reality and solve challenging design problems.
      </p>
      <p className="about-paragraph">
        Whether it's wireframing, prototyping, or implementing responsive layouts, I'm committed to delivering
        top-notch user experiences that leave a lasting impression.
      </p>
      <p className="about-paragraph">
        Outside of my work, I'm an avid learner, always seeking opportunities to grow my skills and explore new
        design patterns. I'm excited about the endless possibilities that Software Development Industry offers and look
        forward to creating impactful digital solutions.
      </p>

      <div className="social-icons">
        <a href="https://github.com/shantanutewari12" target="_blank" rel="noopener noreferrer">
          <BsGithub className="icon" />
        </a>
        <a href="https://www.linkedin.com/in/shantanutiwari12/" target="_blank" rel="noopener noreferrer">
          <BsLinkedin className="icon" />
        </a>
        <a href="https://shantanu-portfolio12.netlify.app/" target="_blank" rel="noopener noreferrer">
          <BsWebcamFill className="icon" />
        </a>
      </div>
    </div>
  );
}

export default About;
